const blockShare = () => {
  const shareBlock = $('#share-this-page');
  if (!shareBlock) return;
  const shareLinks = shareBlock.find('.accordion-content a');
  const currentPageUrl = window.location;
  shareLinks.each((index, link) => {
    if ($(link).attr('href').includes('mailto')) {
      $(link).attr('href', `mailto:?body=${currentPageUrl}`)
    }
  })
};

export default blockShare;
